module.exports = __webpack_public_path__ + "static/media/message_icon.75d49048.svg";